export const environment = {
  authority: "",
  clientID: "",
  redirectUri: "",
  postLogoutRedirectUri: "",
  protectedResourceMap: [],
  production: true,
  appInsights: {
    instrumentationKey : '3707a383-ba6b-4550-8b15-76884a06e94a'
  },
  defaultCountryId: 1,
  appBaseUrl : window.location.protocol + "//" + window.location.host + "/" ,
  notificationIntervalInMinute: 2,
  receiveSMSIntervalInMinute:2,
  enableRingCentralWidget: true,
  esignatureBaseURL:"https://preprodonlinerental-qa.azurewebsites.net/sign",
  swtBaseURL: '',
  ringcentralWidgetURL:"https://esoftringcentral-qa.azurewebsites.net/adapter.js",
  isFingerPrintEnabled: false,
  ringcentralIVREnabled: '1',
  ringcentralClientNumbers: '',
  isDLScannerEnabled: false,
  dlScannerlicenseKey:'',
  paymentGetCCTStatusInterval: 10,
  cardNotPresentInterval :5,
  paymentMaxWaitTime: 2,
  allowToCreatePortalLogin: true,
  consentScopes:[],
  multipleCountryForNearestLocation: true,
  autoSaveInquiryTime:'1',
  isTopazSignatureEnabled: false,
  syncfusionKey: "Ngo9BigBOggjGyl/VkR+XU9Ff1RDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3hTcEVnWXhaeXZWT2hdVU9yXw==;NxYtFisQPR08Cit/VkR+XU9Ff1RDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3hTcEVnWXhaeXZRRmRZUU9yXw==;Ix0oFS8QJAw9HSQvXkViQlBad1ZJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxVdkNjXX9ZdH1XQmFbUUF9W0I=;NxYtGyMROh0gHDMgDk1jXk9FaF5LVmJLYVB3WmpQdldgdVRMZVVbQX9PIiBoS35RcEVlWXted3BcRGReWURzVEZd",
  azureMapsSubscriptionKey: '',
  tdLocalHostArchitectureFacilities : [56],
  enableNewPaymentArchitecture : false,
  prePayMaxLimit: 60,
  IsCardPaymentLogRequired : false
};
